import { Injectable } from '@angular/core';
import { ShipmentQuery } from 'src/app/models/shipment-query';
import { FilterAssistQuery } from '../../../interfaces/filter-assist-query';
import { BatchService } from '../../../data/batch.service';
import { Observable, of } from 'rxjs';
import { FilterAssist } from '../../../models/filter-assist';
import { map, startWith } from 'rxjs/operators';
import { FilterCategoryEnum } from '../../../enum/filter-category.enum';
import { ShipmentFilterService } from '../services/shipment-filter.service';

@Injectable({
    providedIn: 'root'
})
export class ShipmentBatchFilterService implements FilterAssistQuery<ShipmentQuery> {

    private SHIPMENT_BATCH = 'SHIPMENT_BATCH';

    constructor(private shipmentFilterService: ShipmentFilterService, private batchService: BatchService) {
        shipmentFilterService.registerFilters(this);
    }

    active(query: ShipmentQuery): Observable<FilterAssist[]> {
        if (query.batchId) {
            return this.batchService.get(query.batchId).pipe(
                map(batch => [ {
                    id: this.SHIPMENT_BATCH,
                    description: batch.name,
                    score: 200,
                    parameter: query.batchId,
                    category: FilterCategoryEnum.BATCH
                }])
            );
        }
        return of([]);
    }

    apply(id: string, parameter: any, query: ShipmentQuery): void {
        switch (id) {
            case this.SHIPMENT_BATCH:
                query.batchId = parameter;
                break;
        }
    }

    ids(): string[] {
        return [ this.SHIPMENT_BATCH ];
    }

    match(terms: string): Observable<FilterAssist[]> {
        if (terms.length < 2) {
            return of([]);
        }
        return this.batchService.all().pipe(
            startWith([]),
            map(batches => batches.filter(b => b.name && b.name.toUpperCase().startsWith(terms.toUpperCase()))),
            map(batches => batches.map(b => ({
                id: this.SHIPMENT_BATCH,
                parameter: b.id,
                score: 100,
                description: b.name ? b.name : ('#' + b.id),
                category: FilterCategoryEnum.BATCH
            })))
        );
    }

    unapply(id: string, query: ShipmentQuery): void {
        query.batchId = null;
    }

}
